<!-- Trial Over Page -->
@if (!isLoading) {
  <div class="trial-over-container">
    <div class="trial-over-content">

      <!-- Header Section -->
      <div class="trial-header">
        <img src="assets/img/brand/salesmax.png" alt="Salesmax" class="brand-logo">

        @if (daysRemainingInTrial != null && daysRemainingInTrial > 0 && daysRemainingInTrial <= 3) {
          <div class="trial-badge warning">{{daysRemainingInTrial}} days left</div>
          <h1 class="trial-title">Your trial is ending soon</h1>
          <p class="trial-subtitle">Don't lose the progress you've made with <strong>{{activeAccount.account.accountName}}</strong></p>
        }
        @if (daysRemainingInTrial != null && daysRemainingInTrial <= 0) {
          <div class="trial-badge expired">Trial ended</div>
          <h1 class="trial-title">Your trial for {{activeAccount.account.accountName}} has ended</h1>
          <p class="trial-subtitle">Choose what happens next with your sales workflow</p>
        }
      </div>

      <!-- Main Decision Card -->
      <div class="decision-card">
        <div class="comparison-grid">

          <!-- Without Salesmax -->
          <div class="comparison-side without">
            <h3 class="comparison-title">Without Salesmax</h3>
            <ul class="comparison-list">
              <li class="comparison-item negative">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                </svg>
                <span>Back to Excel sheets and missed follow-ups</span>
              </li>
              <li class="comparison-item negative">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                </svg>
                <span>Lost track of customer conversations</span>
              </li>
              <li class="comparison-item negative">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                </svg>
                <span>Team working in silos, zero visibility</span>
              </li>
              <li class="comparison-item negative">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                </svg>
                <span>Typing the same messages repeatedly</span>
              </li>
              <li class="comparison-item negative">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                </svg>
                <span>Hot leads slipping through the cracks</span>
              </li>
            </ul>
          </div>

          <!-- With Salesmax -->
          <div class="comparison-side with">
            <h3 class="comparison-title">With Salesmax</h3>
            <ul class="comparison-list">
              <li class="comparison-item positive">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
                <span>Every call and message logged automatically</span>
              </li>
              <li class="comparison-item positive">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
                <span>Never miss a follow-up again</span>
              </li>
              <li class="comparison-item positive">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
                <span>Complete visibility across your team</span>
              </li>
              <li class="comparison-item positive">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
                <span>Templates that save 2+ hours daily</span>
              </li>
              <li class="comparison-item positive">
                <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
                <span>Close deals that would've been lost</span>
              </li>
            </ul>
          </div>

        </div>

        <!-- CTA Section -->
        <div class="cta-section">
          <div class="primary-cta">
            <button type="button" class="btn-upgrade">
              Continue With Salesmax
              <span class="discount-badge">Call us</span>
            </button>
            <p class="cta-subtext">Join 1000+ sales teams growing faster</p>
          </div>

          <div class="secondary-cta">
            <button type="button" (click)="extendFreeTrial()" class="btn-extend">
              Need More Time? Call us and we will extend
            </button>
          </div>
        </div>
      </div>

      <!-- Additional Options -->
      <div class="additional-options">
        @if (availableMemberships.length > 0) {
          <div class="workspace-switcher">
            <h3 class="switcher-title">Or switch to another workspace</h3>
            <mat-chip-listbox aria-label="available workspaces" class="workspace-chips">
              @for (membership of availableMemberships; track membership) {
                <mat-chip-option
                  [value]="membership"
                  (selectionChange)="onChipSelectionChange($event, membership)">
                  <span class="chip-name">{{membership.account.accountName | titlecase}}</span>
                  @if (membership.userAccountStatus && membership.userAccountStatus == 'APPROVED') {
                    <span class="chip-badge">Invitation pending</span>
                    <div class="chip-actions">
                      <button type="button" class="chip-btn accept" (click)="acceptMembership($event, membership); $event.stopPropagation()">Accept</button>
                      <button type="button" class="chip-btn reject" (click)="rejectMembership($event, membership); $event.stopPropagation()">Decline</button>
                    </div>
                  }
                </mat-chip-option>
              }
            </mat-chip-listbox>
          </div>
        }

        <div class="sign-out-section">
          <a class="sign-out-link" routerLink='/sign-out' routerLinkActive="active">Sign Out</a>
        </div>
      </div>

    </div>
  </div>
}
<!-- End Trial Over Page -->

